module.exports = __webpack_public_path__ + "img/employer_hero_mobile.74840815.jpg";